module.exports = __webpack_public_path__ + "static/media/comingSoon.18d54904.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/comingSoon.gif
// module id = 48
// module chunks = 0